import { useEffect, useState } from "react";
import styled, { css } from "styled-components";
import { useDispatch, useSelector } from "react-redux";

import { Default } from "Types";
import { instance } from "api";
import { ReduxStates } from "Types";
import { Data as DataType } from "Types/Reducers";
import { actions } from "reducers/redux/data";
import { actions as artistActions } from "reducers/saga/artists";

import AtomPaper from "Components/Atoms/Paper";
// import MoleculeFormText from "Components/Molecules/FormText";

export type PropsType = any;

const Wrap = styled(AtomPaper)`
   margin-top: 5px;
   max-height: 300px;
   overflow-y: scroll;
`;

const Row = styled.div`
   display: flex;
   align-items: center;
   height: 50px;
`;

const Col = styled.div<any>`
   cursor: pointer;
   overflow-wrap: break-word;
   word-break: keep-all;
   ${({ css }) => css}
`;

const Img = styled.img`
   display: inline-block;
   width: 32px;
   height: 32px;
   border-radius: 50%;
`;

// const FormControlWrap = styled(MoleculeFormText.Wrap)``;

export default function OrganismSearchArtists(props: PropsType) {
   const data = useSelector((state: any) => state.data);
   const [categories, setCategories]: any = useState({});
   const resultData = props.data || []; //useSelector((state: any) => state.artists.search);
   const dispatch = useDispatch();
   function dataOnChange(idx: any, name: any) {
      const authorArray = { ...data.author_array, [idx]: `@${idx}(${name})` };
      dispatch({
         type: actions.set,
         payload: {
            ...data,
            author: Object.keys(authorArray)
               .map((idx) => `@${idx}`)
               .join(","),
            author_array: authorArray,
         },
      });

      props.onSelect();
      // dispatch({
      //    type: artistActions.search.reset,
      // });
   }

   useEffect(() => {
      instance
         .get(`https://art-map.co.kr/api/admin/v2/categories/`)
         .then(function (res) {
            const temp: any = {};
            res.data.forEach(function (row: any) {
               temp[row._id] = row.category_name;
            });
            setCategories(temp);
         })
         .catch(function (err) {
            console.log(err);
         });

      return () => {};
   }, []);
   return (
      <Wrap className={props.className} style={props.style} css={props.css}>
         {
            // resultData.status === statuses.resolved &&
            resultData.map((row: any) => {
               // const src = row.worklist && row.worklist[0] ? row.worklist[0] : row.img;
               let src = row.img || row.profile;

               if (!src.match(/^http/iu)) {
                  src = "https://art-map.co.kr/art-map/public" + src;
               }
               return (
                  <Row key={row._id}>
                     <Col
                        css={css`
                           width: 60px;
                           text-align: center;
                        `}
                        onClick={() => dataOnChange(row._id, row.name)}>
                        <Img src={src} />
                     </Col>
                     <Col
                        css={css`
                           margin-left: 0px;
                           width: 80px;
                        `}
                        onClick={() => dataOnChange(row._id, row.name)}>
                        {row.name}
                     </Col>
                     <Col
                        css={css`
                           margin-left: 20px;
                        `}
                        onClick={() => dataOnChange(row._id, row.name)}>
                        {categories[row.category] || ""}
                     </Col>
                  </Row>
               );
            })
         }
      </Wrap>
   );
}
